import * as React from 'react';
import { RegionCard } from '@ui/components';

import './CitiesList.less';

interface Props {
  cities: any[];
  onClick: (region: any) => void;
}

const CitiesList: React.FunctionComponent<Props> = ({ cities, onClick }) => (
  <div className="cities-list">
    {cities.map(city => (
      <RegionCard key={city.id} region={city} onClick={onClick} />
    ))}
  </div>
);

export default CitiesList;



// WEBPACK FOOTER //
// ./src/scenes/Cities/components/CitiesList/CitiesList.tsx